module.exports = __webpack_public_path__ + "img/w24-b3.89ef80a6.jpg";